module.exports = __webpack_public_path__ + "static/media/project-thumbnail14.0545424f.jpg";